const widgets = [
    <Lowercase<string>>"Menu",
    <Lowercase<string>>"Auth",
    <Lowercase<string>>"Subscription",
    <Lowercase<string>>"IAPSubscription",
    <Lowercase<string>>"PostTvSubscription",
    <Lowercase<string>>"PinInput",
    <Lowercase<string>>"Exit"
];
export default widgets;
